import { Map } from 'immutable';

import { createPaginatedListSelector } from 'app/selectors';

export const consoleCommandLogList = createPaginatedListSelector((state) =>
  state.consoleCommandLogs.get('consoleCommandLogList', Map()),
);
